/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Steps_TextInputs */

const en_editor_steps_text = /** @type {(inputs: Editor_Steps_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steps, one per line`)
};

const de_editor_steps_text = /** @type {(inputs: Editor_Steps_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schritte, einer pro Zeile`)
};

/**
* | output |
* | --- |
* | "Steps, one per line" |
*
* @param {Editor_Steps_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_steps_text = /** @type {((inputs?: Editor_Steps_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Steps_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_steps_text(inputs)
	return en_editor_steps_text(inputs)
});